import { SupportedLocale } from "types/i18n/SupportedLocaleEnum";

/** localStorage key holding the visitor's explicit language choice. */
export const LOCALE_STORAGE_KEY = "muggleTestLocale";

/** Query parameter that carries a language in a shared link, e.g. `?lang=zh-CN`. */
export const LOCALE_QUERY_PARAM = "lang";

/** Locale the UI renders in when nothing picks another one. */
export const DEFAULT_LOCALE = SupportedLocale.English;

/** Every shipped locale, in the order the language selector lists them. */
export const SUPPORTED_LOCALES: readonly SupportedLocale[] = [
  SupportedLocale.English,
  SupportedLocale.SimplifiedChinese,
  SupportedLocale.TraditionalChinese,
];

/**
 * The shipped locales visitors can render in. A translated locale left out here is never detected,
 * restored or offered, and the language selector hides itself while only one locale is enabled.
 */
export const ENABLED_LOCALES: readonly SupportedLocale[] = [SupportedLocale.English];

/** Each locale's name in its own script, so a reader who cannot read the current page still finds theirs. */
export const LOCALE_ENDONYMS: Record<SupportedLocale, string> = {
  [SupportedLocale.English]: "English",
  [SupportedLocale.SimplifiedChinese]: "简体中文",
  [SupportedLocale.TraditionalChinese]: "繁體中文",
};

/** Lowercase region subtags whose Chinese readers expect Traditional script. */
export const TRADITIONAL_CHINESE_REGION_SUBTAGS: readonly string[] = ["tw", "hk", "mo"];

/** Lowercase script subtag for Traditional Chinese (`zh-Hant`). */
export const TRADITIONAL_CHINESE_SCRIPT_SUBTAG = "hant";

/** Lowercase script subtag for Simplified Chinese (`zh-Hans`). */
export const SIMPLIFIED_CHINESE_SCRIPT_SUBTAG = "hans";

/** A `{{name}}` placeholder in a copy slot; group 1 is the name. */
export const COPY_PLACEHOLDER_PATTERN = /\{\{\s*(\w+)\s*\}\}/g;

/** An opening or closing markup tag in a copy slot; group 1 is `/` on a closing tag, group 2 the tag name. */
export const COPY_MARKUP_TAG_PATTERN = /<(\/?)([a-zA-Z][a-zA-Z0-9]*)>/g;
